import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Bescheinigung from '../bescheinigung'
import { SingleTestView } from './singletestview';


const cardstyle = {
  margin : '1em'
}

export default class Result extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      printme: false,
      showresult : false,
      singletestview : false,
    }
  }

  printed = () => {
    this.setState({printme : false})
  }


render () {
  const {result, certificate, ownresults} = this.props
  return (
    <div>
        <Card style={cardstyle} className={result.passed ? 'greenrow':'redrow'}>
          <CardContent>
            <Typography color="textSecondary" gutterBottom>
                {'Zeit: '+result.start+' bis '+result.end}
            </Typography>
            <Typography variant="h5" component="h4">
              {result.points+ ' von '+result.maxpoints+' Punkten erreicht'}
            </Typography>
            <Typography  color="textSecondary">
              {result.passed ? 'Bestanden' : 'Nicht bestanden'}
            </Typography>
          </CardContent>
          <CardActions>
            {result.passed && certificate &&
              <Button size="small" variant="outlined" color="secondary" onClick={e => this.setState({printme:true})}>Bescheinigung drucken</Button>
            }
            {result.passed && ownresults &&
            <Button size="small" variant='outlined' color="secondary" onClick={e => this.setState({showresult : this.setState({singletestview:result})})}>Fragen anzeigen</Button>
            }
          </CardActions>
        </Card>
        <Bescheinigung test={result} {...this.props} print={this.state.printme} onPrinted={this.printed}/>
        <SingleTestView {...this.state.singletestview} onclose={e => this.setState({singletestview:false})}/>
      </div>
    )
  }
}
